module.exports = __webpack_public_path__ + "static/media/tablet-android-alt.441de5b4.svg";